export default __webpack_public_path__ + "static/media/lock.3e08560a.png";